import { render, staticRenderFns } from "./ModalCreateCustomerMobile.vue?vue&type=template&id=057f3b3b&scoped=true"
import script from "./ModalCreateCustomerMobile.vue?vue&type=script&lang=js"
export * from "./ModalCreateCustomerMobile.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateCustomerMobile.vue?vue&type=style&index=0&id=057f3b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f3b3b",
  null
  
)

export default component.exports